import React from "react";
import { rctiTimestamp } from "utils/rctiTimestamp";
import "./rctiJourney.css";
export default function RCTIAdjustmentComparison({
  original,
  revised,
  currencyCode = "AUD",
}) {
  if (!original) return null;
  const money = (value) =>
    `${currencyCode} ${Number(value || 0).toLocaleString("en-AU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  const rows = [
    ["Net / subtotal", "totalAmount"],
    ["GST", "totalGSTAmount"],
    ["Total consideration", "finalAmount"],
  ];
  return (
    <section
      className="rcti-adjustment-comparison"
      aria-label="Adjustment comparison"
    >
      <div>
        <h2>Original document</h2>
        <p>
          {original.rctiNumber || "RCTI"} · Version {original.version || 1} ·{" "}
          {rctiTimestamp(original.issuedAt || original.rctiDate)}
        </p>
        <p>
          The previous issued version is preserved in history. The revised
          amount replaces this payable; it does not create a second liability.
        </p>
      </div>
      <div className="rcti-comparison-scroll">
        <table>
          <caption>Original and revised consideration</caption>
          <thead>
            <tr>
              <th scope="col">Accounting · {currencyCode}</th>
              <th scope="col">Original</th>
              <th scope="col">Revised</th>
              <th scope="col">Change</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([label, key]) => {
              const delta =
                (Math.round(Number(revised[key] || 0) * 100) -
                  Math.round(Number(original[key] || 0) * 100)) /
                100;
              return (
                <tr key={key}>
                  <th scope="row">{label}</th>
                  <td>{money(original[key])}</td>
                  <td>{money(revised[key])}</td>
                  <td>
                    {delta > 0 ? "+" : ""}
                    {money(delta)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
